import cookieCommons from 'common/cookieCommons';
import { UseQueryOptions, useQuery } from 'react-query';
import { getUserPlan } from '../apis/tms/plans.api';
import { USER_PLAN_QUERY_KEY } from '../constant/QueryKeyName';
import { USER_PLAN } from '../constant/storage';

const useUserPlan = (
  opt?: Omit<
    UseQueryOptions<unknown, Error, USER_PLAN, string[]>,
    'queryKey' | 'queryFn'
  >
) => {
  const accessToken = cookieCommons.getAccessToken();

  const { data: userPlan } = useQuery([USER_PLAN_QUERY_KEY], getUserPlan, {
    ...opt,
    staleTime: 10 * 60 * 60,
    cacheTime: 10 * 60 * 60,
    enabled: !!accessToken,
  });

  return userPlan;
};

export default useUserPlan;
